








































import {Component, Vue} from 'vue-property-decorator';
import ICognitoUserData from '@/types/cognitoUserData';
import {
  Getter,
  Action,
} from 'vuex-class';

@Component
export default class SignIn extends Vue {
  public $refs!: {
    form: any,
  };

  private loading: boolean = false;
  private user: any = {
    username: null,
    password: null,
  };

  @Getter('guest/auth/username') private username!: string;
  @Action('guest/auth/forgotPassword') private forgotPassword!: (user: ICognitoUserData) => Promise<any>;
  @Getter('guest/auth/challenge') private challenge!: any;
  @Getter('common/rules/all') private rules!: any[];

  public mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
  }

  private async Confirm(e) {
    e.preventDefault();
    if (this.$refs.form.validate()) {
      this.loading = true;
      const res = await this.forgotPassword(this.user);
      if (res) {
        this.$router.push({name: 'ForgotPasswordSubmit'});
      }
      this.loading = false;
    }
  }
}
